import { render, staticRenderFns } from "./DialogAddVideoToBank.vue?vue&type=template&id=430c5f69"
import script from "./DialogAddVideoToBank.vue?vue&type=script&lang=js"
export * from "./DialogAddVideoToBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('430c5f69')) {
      api.createRecord('430c5f69', component.options)
    } else {
      api.reload('430c5f69', component.options)
    }
    module.hot.accept("./DialogAddVideoToBank.vue?vue&type=template&id=430c5f69", function () {
      api.rerender('430c5f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddVideoToBank.vue"
export default component.exports